import React from 'react';
import { BrowserRouter as Router, Link, Switch, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import './navBar.css';
import ProjectEnquiryForm from '../forms/project_enquiry_form/projectEnquiryForm';
import AdminLogin from '../auth/adminLogin';
import Admin from '../admin/admin.js';
import dogealgoLogo from '../assets/logo/dogealgo-logo.png';
import Home from '../home/Home';
import Article from '../article/article.js';
import ArticleIterableCards from '../article/articleIterableCards.js';
import ComputerVision from '../home/computerVision/computerVision.js';

class NavBar extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Router>
        <div className="NavBar">
          <header class="NavBar-header">
            <Navbar collapseOnSelect expand="lg" bg="light" variant="light" >
              <Navbar.Brand href="/home"><img src={dogealgoLogo}
                className="Matrix-logo" alt="logo" />
              </Navbar.Brand>

              <Navbar.Toggle aria-controls="responsive-navbar-nav" />
              <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="mr-auto">

                  {/* <a href="https://danyson.github.io/coaching.html" className="navLink">&nbsp; Coaching for Coding &nbsp;</a>
                  <a href="https://danyson.github.io/python.html" className="navLink">&nbsp; DSA/OOPS &nbsp;</a> */}
                  <Link to="/article" className="navLink">
                    &nbsp; What We Write &nbsp;</Link>
                  <a href="https://www.buymeacoffee.com/dogealgo/extras" className="navLink">
                    &nbsp; What We Build &nbsp;
                  </a>
                  <Link to="/contact" className="navLink">
                    &nbsp; Contact Us &nbsp;</Link>
                  <a href="https://www.buymeacoffee.com/dogealgo" className="navLink">
                    <img src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
                      alt="Buy Me A Coffee"
                      style={{ height: "40px", width: "150px" }} />
                  </a>

                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </header>
        </div>

        <Switch>
          <Route exact path="/contact" render={() => <ProjectEnquiryForm />}></Route>
          <Route exact path="/adminLogin" render={() => <AdminLogin />}></Route>
          <Route exact path="/admin" render={() => <Admin />}></Route>
          <Route exact path="/home" render={() => <Home />}></Route>
          <Route exact path="/computer_vision" render={() => <ComputerVision />}></Route>
          <Route exact path="/" render={() => <Home />}></Route>
          <Route exact path="/article" render={() => <ArticleIterableCards />}></Route>
        </Switch>
      </Router>
    );
  }
}


export default NavBar;
/*<Router>
   <Switch>
     <Route exact path="/" render={() => <Dashboard />}/>
   </Switch>
 </Router>
/*    <NavDropdown title="Dropdown" id="collasible-nav-dropdown">
      <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
      <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
      <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
      <NavDropdown.Divider />
      <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
    </NavDropdown>
  </Nav>
  <Nav>
    <a href="#deets">More deets</a>
    <a eventKey={2} href="#memes">
      Dank memes
</a>
linkClick(event) {
  const element = <span></span>;
  this.setState({
        HomeTag: element
      });
    }
    this.state = {HomeTag:<Home />};
    this.linkClick = this.linkClick.bind(this);
    {this.state.HomeTag}
*/
